/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TimelineRouteImport } from './routes/timeline'
import { Route as ReformRouteImport } from './routes/reform'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ParentsRouteImport } from './routes/parents'
import { Route as NewsRouteImport } from './routes/news'
import { Route as MetricsRouteImport } from './routes/metrics'
import { Route as MethodologyRouteImport } from './routes/methodology'
import { Route as LegislativeRouteImport } from './routes/legislative'
import { Route as FaithRouteImport } from './routes/faith'
import { Route as DocumentsRouteImport } from './routes/documents'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConservativeRouteImport } from './routes/conservative'
import { Route as CongressRouteImport } from './routes/congress'
import { Route as ActionRouteImport } from './routes/action'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CongressIndexRouteImport } from './routes/congress.index'
import { Route as CongressSenateStateLastNameRouteImport } from './routes/congress/senate/$state/$lastName'
import { Route as CongressHouseStateDistrictLastNameRouteImport } from './routes/congress/house/$state/$district/$lastName'

const TimelineRoute = TimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => rootRouteImport,
} as any)
const ReformRoute = ReformRouteImport.update({
  id: '/reform',
  path: '/reform',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ParentsRoute = ParentsRouteImport.update({
  id: '/parents',
  path: '/parents',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsRoute = NewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => rootRouteImport,
} as any)
const MetricsRoute = MetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => rootRouteImport,
} as any)
const MethodologyRoute = MethodologyRouteImport.update({
  id: '/methodology',
  path: '/methodology',
  getParentRoute: () => rootRouteImport,
} as any)
const LegislativeRoute = LegislativeRouteImport.update({
  id: '/legislative',
  path: '/legislative',
  getParentRoute: () => rootRouteImport,
} as any)
const FaithRoute = FaithRouteImport.update({
  id: '/faith',
  path: '/faith',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsRoute = DocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const ConservativeRoute = ConservativeRouteImport.update({
  id: '/conservative',
  path: '/conservative',
  getParentRoute: () => rootRouteImport,
} as any)
const CongressRoute = CongressRouteImport.update({
  id: '/congress',
  path: '/congress',
  getParentRoute: () => rootRouteImport,
} as any)
const ActionRoute = ActionRouteImport.update({
  id: '/action',
  path: '/action',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CongressIndexRoute = CongressIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CongressRoute,
} as any)
const CongressSenateStateLastNameRoute =
  CongressSenateStateLastNameRouteImport.update({
    id: '/senate/$state/$lastName',
    path: '/senate/$state/$lastName',
    getParentRoute: () => CongressRoute,
  } as any)
const CongressHouseStateDistrictLastNameRoute =
  CongressHouseStateDistrictLastNameRouteImport.update({
    id: '/house/$state/$district/$lastName',
    path: '/house/$state/$district/$lastName',
    getParentRoute: () => CongressRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/action': typeof ActionRoute
  '/congress': typeof CongressRouteWithChildren
  '/conservative': typeof ConservativeRoute
  '/contact': typeof ContactRoute
  '/documents': typeof DocumentsRoute
  '/faith': typeof FaithRoute
  '/legislative': typeof LegislativeRoute
  '/methodology': typeof MethodologyRoute
  '/metrics': typeof MetricsRoute
  '/news': typeof NewsRoute
  '/parents': typeof ParentsRoute
  '/privacy': typeof PrivacyRoute
  '/reform': typeof ReformRoute
  '/timeline': typeof TimelineRoute
  '/congress/': typeof CongressIndexRoute
  '/congress/senate/$state/$lastName': typeof CongressSenateStateLastNameRoute
  '/congress/house/$state/$district/$lastName': typeof CongressHouseStateDistrictLastNameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/action': typeof ActionRoute
  '/conservative': typeof ConservativeRoute
  '/contact': typeof ContactRoute
  '/documents': typeof DocumentsRoute
  '/faith': typeof FaithRoute
  '/legislative': typeof LegislativeRoute
  '/methodology': typeof MethodologyRoute
  '/metrics': typeof MetricsRoute
  '/news': typeof NewsRoute
  '/parents': typeof ParentsRoute
  '/privacy': typeof PrivacyRoute
  '/reform': typeof ReformRoute
  '/timeline': typeof TimelineRoute
  '/congress': typeof CongressIndexRoute
  '/congress/senate/$state/$lastName': typeof CongressSenateStateLastNameRoute
  '/congress/house/$state/$district/$lastName': typeof CongressHouseStateDistrictLastNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/action': typeof ActionRoute
  '/congress': typeof CongressRouteWithChildren
  '/conservative': typeof ConservativeRoute
  '/contact': typeof ContactRoute
  '/documents': typeof DocumentsRoute
  '/faith': typeof FaithRoute
  '/legislative': typeof LegislativeRoute
  '/methodology': typeof MethodologyRoute
  '/metrics': typeof MetricsRoute
  '/news': typeof NewsRoute
  '/parents': typeof ParentsRoute
  '/privacy': typeof PrivacyRoute
  '/reform': typeof ReformRoute
  '/timeline': typeof TimelineRoute
  '/congress/': typeof CongressIndexRoute
  '/congress/senate/$state/$lastName': typeof CongressSenateStateLastNameRoute
  '/congress/house/$state/$district/$lastName': typeof CongressHouseStateDistrictLastNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/action'
    | '/congress'
    | '/conservative'
    | '/contact'
    | '/documents'
    | '/faith'
    | '/legislative'
    | '/methodology'
    | '/metrics'
    | '/news'
    | '/parents'
    | '/privacy'
    | '/reform'
    | '/timeline'
    | '/congress/'
    | '/congress/senate/$state/$lastName'
    | '/congress/house/$state/$district/$lastName'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/action'
    | '/conservative'
    | '/contact'
    | '/documents'
    | '/faith'
    | '/legislative'
    | '/methodology'
    | '/metrics'
    | '/news'
    | '/parents'
    | '/privacy'
    | '/reform'
    | '/timeline'
    | '/congress'
    | '/congress/senate/$state/$lastName'
    | '/congress/house/$state/$district/$lastName'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/action'
    | '/congress'
    | '/conservative'
    | '/contact'
    | '/documents'
    | '/faith'
    | '/legislative'
    | '/methodology'
    | '/metrics'
    | '/news'
    | '/parents'
    | '/privacy'
    | '/reform'
    | '/timeline'
    | '/congress/'
    | '/congress/senate/$state/$lastName'
    | '/congress/house/$state/$district/$lastName'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ActionRoute: typeof ActionRoute
  CongressRoute: typeof CongressRouteWithChildren
  ConservativeRoute: typeof ConservativeRoute
  ContactRoute: typeof ContactRoute
  DocumentsRoute: typeof DocumentsRoute
  FaithRoute: typeof FaithRoute
  LegislativeRoute: typeof LegislativeRoute
  MethodologyRoute: typeof MethodologyRoute
  MetricsRoute: typeof MetricsRoute
  NewsRoute: typeof NewsRoute
  ParentsRoute: typeof ParentsRoute
  PrivacyRoute: typeof PrivacyRoute
  ReformRoute: typeof ReformRoute
  TimelineRoute: typeof TimelineRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/timeline': {
      id: '/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof TimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reform': {
      id: '/reform'
      path: '/reform'
      fullPath: '/reform'
      preLoaderRoute: typeof ReformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parents': {
      id: '/parents'
      path: '/parents'
      fullPath: '/parents'
      preLoaderRoute: typeof ParentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news': {
      id: '/news'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof NewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/metrics': {
      id: '/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof MetricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/methodology': {
      id: '/methodology'
      path: '/methodology'
      fullPath: '/methodology'
      preLoaderRoute: typeof MethodologyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legislative': {
      id: '/legislative'
      path: '/legislative'
      fullPath: '/legislative'
      preLoaderRoute: typeof LegislativeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faith': {
      id: '/faith'
      path: '/faith'
      fullPath: '/faith'
      preLoaderRoute: typeof FaithRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conservative': {
      id: '/conservative'
      path: '/conservative'
      fullPath: '/conservative'
      preLoaderRoute: typeof ConservativeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/congress': {
      id: '/congress'
      path: '/congress'
      fullPath: '/congress'
      preLoaderRoute: typeof CongressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/action': {
      id: '/action'
      path: '/action'
      fullPath: '/action'
      preLoaderRoute: typeof ActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/congress/': {
      id: '/congress/'
      path: '/'
      fullPath: '/congress/'
      preLoaderRoute: typeof CongressIndexRouteImport
      parentRoute: typeof CongressRoute
    }
    '/congress/senate/$state/$lastName': {
      id: '/congress/senate/$state/$lastName'
      path: '/senate/$state/$lastName'
      fullPath: '/congress/senate/$state/$lastName'
      preLoaderRoute: typeof CongressSenateStateLastNameRouteImport
      parentRoute: typeof CongressRoute
    }
    '/congress/house/$state/$district/$lastName': {
      id: '/congress/house/$state/$district/$lastName'
      path: '/house/$state/$district/$lastName'
      fullPath: '/congress/house/$state/$district/$lastName'
      preLoaderRoute: typeof CongressHouseStateDistrictLastNameRouteImport
      parentRoute: typeof CongressRoute
    }
  }
}

interface CongressRouteChildren {
  CongressIndexRoute: typeof CongressIndexRoute
  CongressSenateStateLastNameRoute: typeof CongressSenateStateLastNameRoute
  CongressHouseStateDistrictLastNameRoute: typeof CongressHouseStateDistrictLastNameRoute
}

const CongressRouteChildren: CongressRouteChildren = {
  CongressIndexRoute: CongressIndexRoute,
  CongressSenateStateLastNameRoute: CongressSenateStateLastNameRoute,
  CongressHouseStateDistrictLastNameRoute:
    CongressHouseStateDistrictLastNameRoute,
}

const CongressRouteWithChildren = CongressRoute._addFileChildren(
  CongressRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ActionRoute: ActionRoute,
  CongressRoute: CongressRouteWithChildren,
  ConservativeRoute: ConservativeRoute,
  ContactRoute: ContactRoute,
  DocumentsRoute: DocumentsRoute,
  FaithRoute: FaithRoute,
  LegislativeRoute: LegislativeRoute,
  MethodologyRoute: MethodologyRoute,
  MetricsRoute: MetricsRoute,
  NewsRoute: NewsRoute,
  ParentsRoute: ParentsRoute,
  PrivacyRoute: PrivacyRoute,
  ReformRoute: ReformRoute,
  TimelineRoute: TimelineRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
